import { render, staticRenderFns } from "./SnapshotCarrier.vue?vue&type=template&id=32ab6fc6&"
import script from "./SnapshotCarrier.vue?vue&type=script&lang=js&"
export * from "./SnapshotCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports